import React from 'react'
import { Typography } from '@xprog/prensa'
import * as t from '../types'

const Label = (props: t.ContainerProps) =>
  <Typography
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Typography>

Label.defaultProps = {
  defaultCss: {
    color: 'black',
    fontFamily: '$primary',
    fontSize: '22px',
    fontWeight: 700,
    m: '$0',
    width: '100%'
  }
}
export {
  Label
}